// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3DMdN","legacyBtn":"MutateMid_legacyBtn__2upyn"};